import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import OrderCheckDuplicatePage from "./pages/OrderCheckDuplicatePage.vue";
import OrderUpdateDeliveryModePage from "./pages/OrderUpdateDeliveryModePage.vue";
import OrderHoldPage from "./pages/OrderHoldPage.vue";
import OrderHoldListPage from "./pages/OrderHoldListPage.vue";
import OrderUpdateMcStatusPage from "./pages/OrderUpdateMcStatusPage.vue";

export const OrderRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "order"
) => [
  {
    name: "OrderCheckDuplicatePage",
    path: `${prefix}/checkdup`,
    component: OrderCheckDuplicatePage,
    meta: { title: "Check Duplicate Order" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.DUPLICATE_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "OrderUpdateDeliveryModePage",
    path: `${prefix}/updatedeliverymode`,
    component: OrderUpdateDeliveryModePage,
    meta: { title: "Update Delivery Mode Order" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.UPDATE_DELIVERY_MODE
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "OrderHoldPage",
    path: `${prefix}/hold-order`,
    component: OrderHoldPage,
    meta: { title: "Hold Order" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.HOLD_ORDER_STATUS
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "OrderHoldListPage",
    path: `${prefix}/hold-list`,
    component: OrderHoldListPage,
    meta: { title: "List Hold Order" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.HOLD_ORDER_LIST
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "OrderUpdateMcStatusPage",
    path: `${prefix}/updatemcstatus`,
    component: OrderUpdateMcStatusPage,
    meta: { title: "Update Mc Status to 5" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.UPDATE_MC_STATUS_TO_5
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
